<template>
  <div class="bottom">
    <div class="menu">
      <ul v-for="(item, index) in lists" :key="index" class="bottom-list">
        <li class="list" @click="go(item.namePath)">{{ item.name }}</li>
      </ul>
      <div class="icon"></div>
    </div>
    <div class="domain">
      <span class="company-name">深圳市华运昌供应链有限公司</span>
      <span class="domain-no" @click="newPage('https://beian.miit.gov.cn')"
        >粤ICP备2021146102号-1</span
      >
    </div>
    <div class="blank"></div>
  </div>
</template>

<script>
import { myMixin } from '../../mixin'
export default {
  name: 'Bottom',
  mixins: [myMixin],
  data() {
    return {
      lists: [
        { name: '关于我们', namePath: 'Regard', class: '' },
        { name: '服务范围', namePath: 'Services', class: '' },
        { name: '新闻中心', namePath: 'Newcenter', class: '' },
        { name: '联系我们', namePath: 'Contact', class: '' }
      ]
    }
  }
}
</script>

<style scoped>
.menu {
  display: flex;
  justify-content: center;
}

.list {
  color: white;
  padding: 30px 50px;
  float: left;
  cursor: pointer;
}

.list:hover {
  background-color: rgb(225, 171, 63);
}

.disabled {
  pointer-events: none;
  color: #000000;
}

.domain {
  display: flex;
  justify-content: center;
  padding: 20px;
  color: #ffffff;
  font-size: 12px;
}

.domain > .company-name {
  padding-right: 20px;
}

.domain > .domain-no {
  cursor: pointer;
}

.blank {
  height: 60px;
}

.bottom {
  background: rgb(40, 52, 83);
}
</style>
